import { useEffect, useRef, useState } from "react";
import { BannerSkeletonTemplateWrapper } from "../../StayUpToDateComponents/BannerSkeletonTemplateWrapper";
import {
  attachSrcDocEmbedHeight,
  buildEmbedSrcDoc,
  isSelfSizingEmbedHtml,
  parseEmbedHeight,
} from "../../../../../Utils/helpers/embedCodeHtml";

const EmbedFormComponentFrontend = (props: any) => {
  const { designTokens } = props;
  const { component } = props;
  const html = component?.details || "";
  const title = String(props.title || component?.name || "").trim();
  const srcDoc = buildEmbedSrcDoc(
    stampLibEmbedSrc(
      html,
      String(component?.id || ""),
      String(props.user_id || component?.user_id || ""),
    ),
  );
  // Skip skeleton when embed HTML is already present (e.g. remount on edit open).
  const [loading, setLoading] = useState(() => !html);
  const [iframeHeight, setIframeHeight] = useState(() => parseEmbedHeight(html));
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if (!html) {
      setLoading(false);
      return;
    }
    if (!loading) return;
    const t = window.setTimeout(() => setLoading(false), 400);
    return () => window.clearTimeout(t);
  }, [html, loading]);

  useEffect(() => {
    if (loading || !html || !iframeRef.current) return;
    return attachSrcDocEmbedHeight(iframeRef.current, setIframeHeight, {
      requireSizeMessage: isSelfSizingEmbedHtml(html),
    });
  }, [loading, html]);

  useEffect(() => {
    const handleRedirect = props.handleRedirect;
    if (typeof handleRedirect !== "function") return;
    const onMessage = (event: MessageEvent) => {
      const data = event.data;
      if (!data || data.type !== "SB_EMBED_CLICK" || !data.post_id) return;
      const doc = iframeRef.current?.contentDocument;
      if (!doc) return;
      const nested = doc.querySelectorAll("iframe");
      let owned = false;
      for (let i = 0; i < nested.length; i++) {
        if (nested[i].contentWindow === event.source) {
          owned = true;
          break;
        }
      }
      if (!owned) return;
      handleRedirect(
        data.post_id,
        data.media_url,
        data.platform,
        data.name,
        data.title || title,
        data.isLinks,
        props.from,
      );
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [props.handleRedirect, props.from, title]);

  return (
    <>
      {title ? (
        <div className="mainDiv">
          <p
            className="component-name"
            style={{
              height: "auto",
              fontFamily: designTokens?.primaryFontFamily,
            }}
          >
            {title}
          </p>
        </div>
      ) : null}
      {loading ? (
        <BannerSkeletonTemplateWrapper secondaryColor={designTokens?.secondaryColor} />
      ) : !html ? null : (
        <div
          className="outter-section-banner-subcomponent-embed"
          style={{
            overflow: "hidden",
            border: "none",
            boxShadow: "none",
            backgroundColor: "#ffffff",
          }}
        >
            <div
              style={{
                width: "100%",
                height: iframeHeight,
                borderRadius: "8px",
                backgroundColor: "#f5f5f5",
                lineHeight: 0,
                border: "none",
                overflow: "hidden",
                display: "block",
              }}
            >
              {component?.details ? (
                <iframe
                  srcDoc={srcDoc}
                  ref={iframeRef}
                  title="Embedded content"
                  style={{height: iframeHeight, width:"100%", border:"none", display: "block"}}
                />
              ) : (
                <div style={{ textAlign: "center", paddingTop: "20px" }}>
                  No preview available
                </div>
              )}
            </div>
          </div>
        
      )}
    </>
  );
};

function stampLibEmbedSrc(html: string, blockId: string, userId: string) {
  const id = blockId.trim();
  if (!html || !id || typeof document === "undefined") return html;
  const temp = document.createElement("div");
  temp.innerHTML = html;
  temp.querySelectorAll("iframe").forEach((frame) => {
    const src = frame.getAttribute("src") || "";
    if (!src.includes("/component/")) return;
    let url: URL;
    try {
      url = new URL(src, window.location.href);
    } catch {
      return;
    }
    url.searchParams.set("sb_lib", id);
    if (userId.trim()) url.searchParams.set("sb_uid", userId.trim());
    frame.setAttribute("src", url.toString());
  });
  return temp.innerHTML;
}

export default EmbedFormComponentFrontend;
